export default "__VITE_ASSET__Bugyjoj___"